import * as stylex from "@stylexjs/stylex";
import SecondaryBrandsBanner from "components/secondary-brands-banner";
import { motion, useAnimation, useCycle } from "framer-motion";
import React from "react";
import { useInView } from "react-intersection-observer";
import { AspectRatioContainer } from "../../components/aspect-ratio";
import { breakpoints, colors, layoutAreas } from "../../materials/consts.stylex";
import { gridCenteredMaxWidthAreas, layout } from "../../materials/layout.stylex";
const brandmark = new URL("../../assets/ic_brandmark_40dp.svg", import.meta.url).href;
const stylexStyles = {
    root: {
        kWkggS: "xdutcdc",
        kBCFzs: "x1lx81y2",
        k9llMU: "xi217zw",
        kC13JO: "xc5u9eb",
        kGO01o: "xo0ha1f",
        kLKAdn: "xexx8yu xgzd89t",
        kMwMTN: "x1vc0dw",
        kmkexE: "x1d1sdcu",
        kAzted: "x1h7u7uw x1r3yqdr",
        keoZOQ: "xdj266r",
        $$css: true
    }
};
export const IndexHero = ({ children })=>{
    const [rotate, cycleRotate] = useCycle(360, 0, 720);
    const [firstRender, setFirstRender] = React.useState(true);
    const [ref, inView] = useInView();
    const controls = useAnimation();
    const transition = {
        type: "inertia",
        velocity: 200,
        power: 1.5,
        restDelta: 10
    };
    React.useEffect(()=>{
        controls.start({
            rotate,
            transition: {
                ...transition,
                ...firstRender && {
                    delay: 1
                }
            }
        });
    }, [
        controls,
        firstRender,
        rotate,
        transition
    ]);
    return <>
      <div {...stylex.props(layout.gridCenteredMaxWidth, stylexStyles.root)}>
        <div className="x1yedbjw x78zum5 x1qughib x3ieub6 xdjzykv xh8yej3 x1vuk045 x15fnm84 x1qs66ub x1cy8zhl xc23nkm x8i9s90">
          { /* Content comes from MDX (see content/<locale>/index.mdx), rendered via the shared
           * markdown provider — StyleX can't reach its h1/p elements directly, so their
           * type styles live in style.global.css, scoped by this marker class. */ }
          <div className={`index-hero-text ${({
        className: "x78zum5 xl56j7k xdt5ytf"
    }).className}`}>{children}</div>

          <div role="presentation" className="x78zum5 x6s0dn4 xl56j7k xh8yej3 x5rlx3t x1uzpmc9 x1p7g625 xqui205 x1e2mlow xuc0mqo x1oo3vh0 xh3eqxm x1bew4lu xv20lir" ref={ref}>
            <AspectRatioContainer>
              <motion.img src={brandmark} className="xh8yej3 x87ps6o" animate={controls} onMouseMove={()=>{
        firstRender && setFirstRender(false);
        cycleRotate();
    }} onAnimationComplete={()=>{
        firstRender && setFirstRender(false);
        inView && cycleRotate();
    }} alt=""></motion.img>
            </AspectRatioContainer>
          </div>
        </div>
        <div className="x1hdmf5y xdj266r x1n2onr6">
          <SecondaryBrandsBanner flipped/>
        </div>
      </div>
    </>;
};
